import { SuitesType } from '@api';
import { DotNotationPaths } from '@common';
import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueSuitesTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_SUITES.ROWS'>;
  accessor: DotNotationPaths<SuitesType>;
};

export const venueSuitesRows: VenueSuitesTableRowType[] = [
  {
    label: 'SEATS',
    accessor: 'seats',
  },
  {
    label: 'UPLIFT',
    accessor: 'uplift',
  },
  {
    label: 'SHARE',
    accessor: 'share',
  },
  {
    label: 'NOTES',
    accessor: 'notes',
  },
];
